// extracted by mini-css-extract-plugin
module.exports = {"root":"CheckBox_root__2ptfE","checked":"CheckBox_checked__2pcUR","checkmark":"CheckBox_checkmark__1QyFj","singleLine":"CheckBox_singleLine__LUyb5"};